export default __webpack_public_path__ + "static/media/Peter_Icon.b0af4d5f.png";